import { Injectable } from '@angular/core';
import { NotificationsType } from '@cargos/sprintpay-models';
import { NotificationsService, StorageService } from '@cargos/sprintpay-services';
import { Banner } from '@cargos/sprintpay-ui';
import { BehaviorSubject, map, Observable, take } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class BannersService {
    private notifications: BehaviorSubject<NotificationsType[]> = new BehaviorSubject<NotificationsType[]>([]);
    private banners: BehaviorSubject<Banner[]> = new BehaviorSubject<Banner[]>([]);
    private touBanner: BehaviorSubject<Banner | null> = new BehaviorSubject<Banner | null>(null);

    constructor(
        private notificationsService: NotificationsService,
        private storageService: StorageService
    ) {
        const banner: Banner | null = this.storageService.getElement('tou_banner');
        if (banner) {
            this.setAndSaveTouBanner(banner);
        }
    }

    setNotifications(notifications: NotificationsType[]): void {
        this.notifications.next(notifications);
    }

    getNotifications(): Observable<NotificationsType[]> {
        return this.notifications.asObservable();
    }

    getCustomerNotificationsRequest(): Observable<NotificationsType[]> {
        return this.notificationsService.getCustomerNotifications();
    }

    isForteEcheckDisabled(): Observable<boolean> {
        return this.getNotifications().pipe(
            take(1),
            map((notifications: NotificationsType[]) => {
                return !!notifications.find(
                    (notification) => notification.name === 'Regions migration' && notification.styleClass === 'error'
                );
            })
        );
    }
    setAndSaveTouBanner(banner: Banner | null): void {
        const freshBanner = banner ? { ...banner, display: true } : null;
        this.setTOUBanner(freshBanner);
        this.saveCurrentTOUBanner(freshBanner);
    }

    setTOUBanner(banner: Banner | null): void {
        this.touBanner.next(banner);
    }

    saveCurrentTOUBanner(banner: Banner | null): void {
        this.storageService.saveElement('tou_banner', banner);
    }

    getTOUBanner(): Observable<Banner | null> {
        return this.touBanner.asObservable();
    }

    getBanners(): Observable<Banner[]> {
        return this.banners.asObservable();
    }

    setBanners(banners: Banner[]): void {
        this.banners.next(banners);
    }
}
